import { PropsWithChildren } from 'react'

import {
  IconDragHandle,
  GreyGrey60,
  GreyWhite,
  type HandleProps,
  Flex
} from '@sequencehq/core-components'
import { Row } from './Row'
import { Cell } from './Cell'

export const LineItemsTableComponent = ({ children }: PropsWithChildren) => (
  <Flex flexDir="column" width="100%">
    {children}
  </Flex>
)

const Header = ({
  showActionColumn = true
}: {
  showActionColumn?: boolean
}) => (
  <Row
    name={<Cell.Header value="Name" />}
    qty={<Cell.Header value="Qty" />}
    rate={<Cell.Header value="Rate" />}
    tax={<Cell.Header value="Tax" />}
    amount={<Cell.Header value="Amount" />}
    action={showActionColumn || undefined}
  />
)

const DragHandle = (handleProps: HandleProps) => (
  <Flex
    width="26px"
    left="-26px"
    height="100%"
    position="absolute"
    opacity="0"
    _groupHover={{ opacity: 1 }}
    justifyContent="flex-end"
    alignItems="center"
    background={GreyWhite}
    cursor="grab"
    pr="8px"
    {...handleProps.attributes}
    {...handleProps.listeners}
  >
    <IconDragHandle color={GreyGrey60} />
  </Flex>
)

export const LineItemsTable = Object.assign(LineItemsTableComponent, {
  Row,
  Cell,
  Header,
  DragHandle
})
